//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/Builder.js";
import "../no/SelectCurveList.js";
import "../no/SelectCurve.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"EdgesPrepared",1,0],[0,"EditingManagedAttributeGroup",1,0],[1,"Joint",0,"SelectCurveList",0],[0,"JointExitBuilder",0,"Weld.JointExitBuilder",0],[0,"LeaveLooseEndValue",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"LeaveLooseStartValue",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"PrimaryRootOpening",1,0],[0,"PrimaryThicknessUser",1,0],[0,"RootOpening",1,0],[0,"RootOpeningOption",1,0],[0,"SecondaryRootOpening",1,0],[0,"SecondaryThicknessUser",1,0],[1,"ValueSegment",0,"SelectCurve",0],[0,"ValuesApplyOption",1,0],[0,"ValuesOption",1,0]],[[[],"RecreateCurves",{},0,0],[[],"DeleteExitBuilder",{},0,0],[["feature"],"ReadEdgePrepValues",{},1,0],[["curve"],"ReadEdgePrepValuesFromCurve",{},1,0],[["value"],"GetSegmentFromIndex",{R_:{segment:"Curve"}},1,0],[["path","reversedPath"],"CreatePathCurvesForLeaveLoose",{},0,0]],[]];
SPLM.Weld.EdgePrepValuesBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.EdgePrepValuesBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.EdgePrepValuesBuilder.Option = Object.freeze({
    "Entered" : "Entered", "Computed" : "Computed"});

SPLM.Weld.EdgePrepValuesBuilder.Apply = Object.freeze({
    "ToAllValues" : "ToAllValues", "ToChangedValuesOnly" : "ToChangedValuesOnly"});

export default SPLM;